import type { FC } from "react";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { ContactUsThanksPortableModal } from "app/pages/sales-intelligence/common-components/ContactUsModal/ContactUsThanksPortableModal";
import { useContactUsThanksModal } from "app/pages/sales-intelligence/common-components/ContactUsModal/useContactUsThanksModal";
import { GainAccessButton } from "app/pages/sales-intelligence/common-components/GainAccessButton";
import { AssetsService } from "app/services/AssetsService";

import {
    StyledGainAccessBtnWrapper,
    StyledGainAccessContainer,
    StyledGainAccessSubTitle,
    StyledGainAccessTitle,
} from "./styles";
import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

type ContactsLockedHookProps = {
    title: string;
    subTitle: string;
    onClick?: () => void;
};

const ContactsLockedHook: FC<ContactsLockedHookProps> = ({ title, subTitle, onClick }) => {
    const { isThanksModalOpen, openThanksModal, closeThanksModal } = useContactUsThanksModal();

    const handleOnCLick = () => {
        requestFeature("SI contacts");
        openThanksModal();
        onClick?.();
    };

    return (
        <StyledGainAccessContainer>
            <div>
                <img
                    src={AssetsService.assetUrl("/images/gain-access-lock.svg")}
                    alt="Gain access"
                    width={219}
                />
            </div>
            <I18n
                dangerouslySetInnerHTML
                component={StyledGainAccessTitle}
            >
                {title}
            </I18n>
            <I18n
                dangerouslySetInnerHTML
                component={StyledGainAccessSubTitle}
            >
                {subTitle}
            </I18n>
            <StyledGainAccessBtnWrapper>
                <GainAccessButton
                    type="trial"
                    onClick={handleOnCLick}
                    data-automation="si.contacts.hook.get-access.button"
                />
            </StyledGainAccessBtnWrapper>
            <ContactUsThanksPortableModal
                isOpen={isThanksModalOpen}
                onClose={closeThanksModal}
            />
        </StyledGainAccessContainer>
    );
};

export default ContactsLockedHook;
